import { ChangeEvent, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import './CustomSearch.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

interface CustomSearchProps {
  onSearch: (searchQuery: string | number) => void;
  onClear: () => void;
  defaultValue: string | number | null;
  localStorageItemName: string;
}

const CustomSearch = ({ onSearch, onClear, defaultValue, localStorageItemName }: CustomSearchProps): JSX.Element => {
  const [query, setQuery] = useState<string>(defaultValue !== null ? defaultValue.toString() : '');

  let input;

  const handleClickSearch = () => {
    onSearch(query);
  };

  const resetSearchQuery = () => {
    setQuery('');
    onClear();
    localStorage.setItem(localStorageItemName, '');
  };

  const handleSearchValueChange = (value: string | number) => {
    setQuery(value.toString());
    localStorage.setItem(localStorageItemName, value.toString());
    onSearch(value);
  };

  useEffect(() => {
    handleClickSearch();
  });

  return (
    <div className="d-flex w-50 custom-search-container">
      <input
        className="form-control"
        type="text"
        ref={(n) => (input = n)}
        value={query}
        onChange={(event: ChangeEvent<HTMLInputElement>) => handleSearchValueChange(event.target.value)}
      />
      {query !== '' && (
        <Button className="custom-reset-search " variant="danger" onClick={resetSearchQuery}>
          <FontAwesomeIcon icon={faTimes} />
        </Button>
      )}
    </div>
  );
};

export default CustomSearch;
